import { Dispatch } from "redux"

export const TOAST_ERROR = "TOAST_ERROR"
export const TOAST_SUCCESS = "TOAST_SUCCESS"
export const TOAST_CLEAR = "TOAST_CLEAR"

const action = {
  error: TOAST_ERROR,
  success: TOAST_SUCCESS
}

export function showToast(message: string, style: keyof typeof action = "success") {
  const type = action[style]

  return (dispatch: Dispatch) => {
    dispatch({
      type,
      payload: { message }
    })
    setTimeout(() => {
      dispatch({
        type: TOAST_CLEAR
      })
    }, 5000)
  }
}
